import { event, selectAll, addClass, removeClass } from "../utils/utils";


export class CollapsibleCard {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.openCollapsibleCard = selectAll("[data-open-collapsible-card]");
  }

  render() {
    this.collapsibleToggle();
  }

  collapsibleToggle = () => {
    for (var i = 0; i < this.openCollapsibleCard.length; i++) {
      this.openCollapsibleCard[i].addEventListener("click", function () {
        const collapsibleCard = this.nextElementSibling;
        const collapsibleCardChildren = collapsibleCard.querySelectorAll('a');
               
        if (this.classList.contains("active")) {
          removeClass(this, "active");
          collapsibleCard.hidden = true;
          this.setAttribute("aria-expanded", false);
          collapsibleCard.setAttribute("tabindex", "-1");
        } else {
          let collapsible = this.closest('.shopify-section');
          collapsible.querySelector('.active') !== null 
          ? collapsible.querySelector('.active').nextElementSibling.hidden = true
          : '';

          collapsible.querySelector('.active')?.nextElementSibling.setAttribute("tabindex", "-1");
          collapsible.querySelector('.active')?.setAttribute('aria-expanded', false);
          collapsible.querySelector('.active')?.classList.remove('active');
  
          addClass(this, "active");
          collapsibleCard.hidden = false;
          this.setAttribute("aria-expanded", true);
          collapsibleCard.setAttribute("tabindex", "1");
          if (collapsibleCardChildren) {
            for (const anchor of collapsibleCardChildren) {
              anchor.classList.add('focus');
              anchor.setAttribute("tabindex", "1");
            }
          }
        }

      });
    };
  }
}